import styled from 'styled-components';
import {
    Banner,
} from '@zillow/constellation';

export const StyledBanner = styled(Banner)`
    margin: -8px -24px 0px -24px;
`;
